import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlannerRoute: InvariantJiraRoute = {
	name: 'software-planner',
	path: '/jira/software/projects/:projectKey/planner',
	exact: true,
};
